(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/constants/eid-dialog.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/constants/eid-dialog.js');
'use strict';

const showEidDialog = onSelectEid => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding[svs.components.lbUtils.branding],
    title: 'Hur vill du identifiera dig?',
    icon: 'login',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.DEFAULT,
    allowDimmerClick: true,
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "F\xF6r att s\xE4tta en spelpaus beh\xF6ver du identifiera dig.<br>V\xE4lj det alternativ som passar dig b\xE4st."
    }],
    actions: [{
      title: 'Freja eID',
      callback: () => {
        dialog.close();
        onSelectEid('FREJA_EID');
      }
    }, {
      title: 'BankID',
      callback: () => {
        dialog.close();
        onSelectEid('BANKID');
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.selfExclusion.showEidDialog = showEidDialog;

 })(window);